import { RadioProps } from '@storeblocks/radio-atom';
import { RadioButtons } from '@storeblocks/radio-buttons';
import { useField } from 'formik';
import { type FC } from 'react';

import { useTexts } from '@/hooks/useTexts';
import { nameof } from '@/util/nameof';

import { FormValues } from '../types/FormValues';
import { PoliticallyExposedPerson } from '../types/PoliticallyExposedPerson';

export const Pep: FC = () => {
  const texts = useTexts();

  const [field, meta, helpers] = useField<PoliticallyExposedPerson>(
    nameof<FormValues>('pep'),
  );

  const pepOptions: RadioProps[] = [
    {
      id: PoliticallyExposedPerson.No,
      value: PoliticallyExposedPerson.No,
      label: texts.orders.signatureRight.pep.no,
    },
    {
      id: PoliticallyExposedPerson.Yes,
      value: PoliticallyExposedPerson.Yes,
      label: texts.orders.signatureRight.pep.yes,
    },
  ].map((option) => ({
    ...option,
    checked: field.value === option.value,
  }));
  return (
    <RadioButtons
      {...field}
      groupName="pep-radio"
      data-test="pep-radio"
      onChange={(e) =>
        helpers.setValue(e.target.value as PoliticallyExposedPerson)
      }
      legendProps={{
        title: texts.orders.signatureRight.pep.title,
        hint: texts.orders.signatureRight.pep.description,
      }}
      options={pepOptions}
      alertMessageType={meta.touched && meta.error ? 'error' : undefined}
      alertMessage={meta.error}
    />
  );
};
